
function roundf(number: number) {
    return Math.round(number * 100) / 100
}

function lerp(start: number, end: number, factor: number) {
    return (start + factor * (end - start));
}

function clamp(value: number, minimum: number, maximum: number) {
    return Math.max(minimum, (Math.min(value, maximum)));
}

interface camera {
    x: number,
    y: number,
    zoom: number,
    w: number,
    h: number,
    dragging: boolean,
    drag_x: number,
    drag_y: number,
};

class Camera2d {
    camera: camera;
    screen: camera;
    constructor(width: number, height: number) {
        this.camera = {
            x: 0, // Math.round(width / 2),
            y: 0, // Math.round(height / 2),
            zoom: 1.0,
            w: width,
            h: height,
            dragging: false,
            drag_x: 0,
            drag_y: 0,
        };
        this.screen = {
            x: Math.round(width / 2),
            y: Math.round(height / 2),
            zoom: 1.0,
            w: width,
            h: height,
            dragging: false,
            drag_x: 0,
            drag_y: 0,
        };
    };
};

function add_listeners(camera: Camera2d) {
    document.addEventListener("wheel", (event: WheelEvent) => {
        if (event.deltaY > 0) {
            // Zoom out
            camera.screen.zoom -= 0.05;
            
            if (camera.screen.zoom < 1) camera.screen.zoom = 1;
        } else {
            // Zoom in
            camera.screen.zoom += 0.05;
        }
        // TODO: Implement a scroll zoom (that zooms towards the mouse cursor)
        // camera.screen.x = event.offsetX;
        // camera.screen.y = event.offsetY;
    });
    document.addEventListener("mousedown", (event) => {
        camera.camera.dragging = true;
        camera.camera.drag_x = event.offsetX;
        camera.camera.drag_y = event.offsetY;
    });
    document.addEventListener("mouseup", () => {
        camera.camera.dragging = false;

    });
    document.addEventListener("mousemove", (event) => {
        if (camera.camera.dragging) {
            event.preventDefault();
            camera.screen.x = (event.offsetX < 0) ? camera.screen.x : event.offsetX;
            camera.screen.y = (event.offsetY < 0) ? camera.screen.y : event.offsetY;
        }
    })
}

function screen_to_world(camera: Camera2d) {

    camera.screen.zoom = roundf(camera.screen.zoom);

    let old_width = camera.camera.w;
    let old_height = camera.camera.h
    camera.camera.w = Math.ceil(camera.screen.w / camera.screen.zoom);
    camera.camera.h = Math.ceil(camera.screen.h / camera.screen.zoom);
    let l = 0.1;
    camera.camera.w = lerp(old_width, camera.camera.w, l);
    camera.camera.h = lerp(old_height, camera.camera.h, l);

    
    let old_x = camera.camera.x;
    let old_y = camera.camera.y;
    camera.camera.x = camera.screen.x - Math.round(camera.camera.w / 2);
    camera.camera.y = camera.screen.y - Math.round(camera.camera.h / 2);
    
    camera.camera.x = clamp(camera.camera.x, 0, camera.screen.w - camera.camera.w);
    camera.camera.y = clamp(camera.camera.y, 0, camera.screen.h - camera.camera.h);

    camera.camera.x = lerp(old_x, camera.camera.x, l);
    camera.camera.y = lerp(old_y, camera.camera.y, l);
    
}

interface requestAnimationID {
    ID: number;
    RUNNING: boolean;
    SPEED: number;
    PAUSED: boolean;
}

// interface Vec2 {
//     x: number,
//     y: number
// }

class Buffer {
    buffer: ImageData;
    index: number;
    position: number;
    row: number;
    constructor(width: number, height: number) {
        this.buffer = new ImageData(width, height);
        this.index = 0;
        this.position = 0;
        this.row = 0;
    }
    set(r: number, g: number, b: number, a: number) {
        if (this.index >= this.buffer.data.length) {
            // We reached the end of the buffer
            this.shift();
        }
        let arr = [r,g,b,a];
        for (let i = 0; i < 4; i++) {
            this.buffer.data[this.index] = arr[i]
            this.index++;
        }
        this.position = this.index / 4;
        this.row = Math.floor((this.position) / this.buffer.width);
        console.assert(this.index <= this.buffer.data.length);
    }
    reset() {
        this.index = 0;
    }
    zero() {
        this.buffer.data.fill(0);
    }
    new(width: number, height: number) {
        this.buffer = new ImageData(width, height);
        this.index = 0;
    }
    shift() {
        let start = Math.round(this.buffer.data.length / 2);
        this.buffer.data.set(this.buffer.data.slice(start, this.buffer.data.length), 0);
        this.index = start;
    }
}

// convert an integer to a string representation of an 8 bit binary set
function integer_to_binary(integer: number): string {
    return integer.toString(2).padStart(8, "0");
}

// Fill the rule array with the correct bits
function populate_rules(number: number, rules: number[]) {
    let n = integer_to_binary(number);
    for (let i = 0; i < 8; i++) {
        let s = n[i];
        rules[i] = s.charCodeAt(0) - 48;
    }
}

// Calculate the state of the next row
function calculate_next_row(rules: number[]) {
    if (!row) throw Error("No row");
    if (!next_row) throw Error("No row");
    for (let i = 0; i < row.length; i++) {
        let left = (i - 1 + width) % width;
        let right = (i + 1) % width;
        let state_left =  row[left];
        let state_middle = row[i];
        let state_right = row[right];
        let new_state = calculate_state(state_left, state_middle, state_right, rules);
        next_row[i] = new_state;
    }
    row.set(next_row);
}

// Render our row buffer into the real image buffer
function render_into_buffer(buffer: Buffer, row: Uint8ClampedArray) {
    for (let i = 0; i < row.length; i++) {
        if (row[i] == 0) {
            buffer.set(0,0,0,0);
        } else {
            buffer.set(255,255,255,255);
        }
    }
}

function render_to_screen(ctx: CanvasRenderingContext2D, shadow: OffscreenCanvasRenderingContext2D, 
                          offscreen: OffscreenCanvas, buffer: Buffer, camera: Camera2d) {
    clear_screen(ctx);
    let x = 0;
    let y = 0;
    y = height - buffer.row;
    if (camera.camera.zoom <= 0) {
        ctx.putImageData(buffer.buffer, x, y);
        return; // Don't do the rest if you don't have to
    }
    shadow.putImageData(buffer.buffer, 0, y);// We just put everything on the shadow canvas.
    shadow.drawImage(offscreen, 0, 0);
    let bitmap = createImageBitmap(offscreen, 0, 0, width, height);
    bitmap.then((image) => {
        screen_to_world(camera);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(image, camera.camera.x, camera.camera.y, camera.camera.w, camera.camera.h, 0, 0, width, height);
    });
    
    clear_screen(shadow);
}
    

// Set the middle pixel to 1
function prefill_row(row: Uint8ClampedArray) {
    let center = Math.floor(row.length / 2);
    for (let i = 0; i < row.length; i++) {
        if (i == center) {
            row[i] = 1;
        } else {
            row[i] = 0;
        }
    }
}

// Calculate the new state for the pixel according to the given rule
function calculate_state(previous: number, current: number, next: number, rules: number[]) {
    let b = 0;
    b |= (previous << 0);
    b |= (current << 1);
    b |= (next << 2);
    return rules[7 - b];
}

// The main loop
function draw(ID: requestAnimationID, ctx: CanvasRenderingContext2D, ctx_shadow: OffscreenCanvasRenderingContext2D, shadow_canvas: OffscreenCanvas, camera: Camera2d) {
    if (ctx == null) throw Error("Context was null");
    if (ctx_shadow == null) throw Error("Context was null");
    if (buffer == null) throw Error("Buffer was null");
    if (row == null) throw Error("Row was null");
    if (ID.PAUSED == false) {
        for (let i = 1; i <= ID.SPEED; i++) {
            calculate_next_row(rules);
            render_into_buffer(buffer, row);
        }
    }
    render_to_screen(ctx, ctx_shadow, shadow_canvas, buffer, camera);
    // draw_status(ctx, camera);
    ID.ID = requestAnimationFrame(draw.bind(draw, ID, ctx, ctx_shadow, shadow_canvas, camera));
}

// Start the animation async
async function start(ID: requestAnimationID, ctx: CanvasRenderingContext2D, ctx_shadow: OffscreenCanvasRenderingContext2D, shadow_canvas: OffscreenCanvas, camera: Camera2d): Promise<requestAnimationID> {
    ID.ID = requestAnimationFrame(draw.bind(draw, ID, ctx, ctx_shadow, shadow_canvas, camera));
    ID.RUNNING = true;
    return new Promise<requestAnimationID>((resolve) => {
        resolve(ID);
    })
}

// Stop the animation
export async function stop(ID: requestAnimationID) {
    let id = ID.ID;
    ID.ID = 0;
    ID.RUNNING = false;
    cancelAnimationFrame(id);
}

function clear_screen(ctx: CanvasRenderingContext2D|OffscreenCanvasRenderingContext2D) {
    ctx.clearRect(0, 0, width, height);
}

// Window resize event
function resize(app: HTMLElement, canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, camera: Camera2d) {
    if (!app) throw Error("No app");
    if (!buffer) throw Error("No buffer");
    clear_screen(ctx);
    canvas.width = app.clientWidth;
    canvas.height = app.clientHeight;
    width = canvas.width;
    height = canvas.height;
    row = new Uint8ClampedArray(width);
    next_row = new Uint8ClampedArray(width);
    prefill_row(row);
    buffer.new(canvas.width, canvas.height * 2);
    camera.camera.x = 0;
    camera.camera.y = 0;
    camera.screen.x = 0;
    camera.screen.y = 0;
    camera.camera.zoom = 1.0
    camera.screen.zoom = 1.0;
    camera.camera.h = height;
    camera.camera.w = width;
}


let width  = 0;
let height = 0;

const rules = new Array(8); // Array for the rule
let row: Uint8ClampedArray|null = null;
let next_row: Uint8ClampedArray|null = null;
let buffer: Buffer|null = null;
// const buffer = new Buffer(width, height * 2); // A buffer object

// document.addEventListener("DOMContentLoaded", () => {
export function init(app: HTMLElement) {
    if (app == null) throw Error("Could not find app element");
    app.style.fontFamily = "Arial";
    app.style.position = "relative";
    if (app == null) throw Error("App was null");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d", {alpha: true});
    if (ctx == null) throw Error("Could not get context");
    width = app.clientWidth;
    height = app.clientHeight;
    canvas.width = width;
    canvas.height = height;
    app.appendChild(canvas);
    const shadow_canvas = new OffscreenCanvas(width, height);
    const ctx_shadow = shadow_canvas.getContext("2d", {alpha: true});
    if (ctx_shadow == null) throw Error("Could not get context");
    row = new Uint8ClampedArray(width);
    next_row = new Uint8ClampedArray(width);
    buffer = new Buffer(width, height * 2);
    const camera = new Camera2d(width, height);
    add_listeners(camera);
    


    const controls = document.createElement("div");

    controls.addEventListener("mouseover", () => {
        controls.style.opacity = "1";
        setTimeout(() => {
            controls.style.opacity = "0";
        }, 4000);
    });

    setTimeout(() => {
        controls.style.opacity = "0";
    }, 4000);

    controls.style.position = "absolute";
    controls.style.top = "5px";
    controls.style.right = "5px";
    controls.style.transition = "opacity 1s ease-in-out";
    controls.style.backgroundColor = "blue";
    const rules_dropdown = document.createElement("select");
    rules_dropdown.title = "Interesting Rules";

    rules_dropdown.addEventListener("change", () =>{
        let new_rule = parseInt(rules_dropdown.value);
        populate_rules(new_rule, rules);
        numbers_pressed = [];
        resize(app, canvas, ctx, camera);
    });

    let interesting_rules = ["30", "90", "110", "184", "124", "137", "193"];

    for (let i = 0; i < interesting_rules.length; i++) {
        let option = document.createElement("option");
        option.title = `Rule ${interesting_rules[i]}`;
        option.text = `Rule ${interesting_rules[i]}`;
        option.value = interesting_rules[i];
        if (option.value == "90") {
            option.selected = true;
        }
        rules_dropdown.appendChild(option);
    }

    controls.appendChild(rules_dropdown);
    app.appendChild(controls);

    let numbers_pressed: number[] = [];
    window.addEventListener("resize", () => {
        resize(app, canvas, ctx, camera);
    });
    window.addEventListener("keydown", (event) => {
        switch (event.code) {
            case "NumpadEnter":
            case "Enter":
                {
                    let str = "";
                    for (let i = 0; i < numbers_pressed.length; i++) {
                        str += numbers_pressed[i].toString();
                    }
                    let new_rule = parseInt(str);
                    populate_rules(new_rule, rules);
                    numbers_pressed = [];
                    resize(app, canvas, ctx, camera);
                }
                break;
            case "Space":
                {
                    if (ID.PAUSED) {
                        ID.PAUSED = false;
                    } else {
                        ID.PAUSED = true;
                    }
                }
                break;
            default:
                if (isNaN(parseInt(event.key)) == false) {
                    // We pressed a number
                    numbers_pressed.push(parseInt(event.key));
                    if (numbers_pressed.length > 3) {
                        numbers_pressed = [];
                    }
                }
                break;
        }
    });
    populate_rules(parseInt(rules_dropdown.value), rules);
    prefill_row(row);
    let ID = {ID: 0, RUNNING: true, SPEED: 1, PAUSED: false};
    let p = start(ID, ctx, ctx_shadow, shadow_canvas, camera);
    p.then((value) => {
        ID = value;
    });
}

